// extracted by mini-css-extract-plugin
export default {"labels":"VisualizzazineAnonima_labels__Yb4+A"};